export type M_ITEM =
  | 'M_Block'
  | 'M_Zone' // Not in csv... but I'm thinking we'll need it
  | 'M_SCD'
  | 'M_InBlockPoint'
  | 'M_OutOfBlockPoint'
  | 'M_Trap'
  | 'M_CurrentLocation'
  | 'M_Property'
  | 'M_Region'
  | 'M_IrrigationZone'

export enum MAP_VISUAL {
  BLOCK = 'BLOCK',
  POINT = 'POINT',
  PROPERTY = 'PROPERTY',
  SCD = 'SCD',
  TRAP = 'TRAP',
  REGION = 'REGION',
  IRRIGATION_ZONE = 'IRRIGATION_ZONE',
  IMAGE_OVERLAY = 'IMAGE_OVERLAY',
}
